import { useTranslation } from "react-i18next";

const TalentCard = ({ title, subtitle, image, index }) => {
  const { t } = useTranslation();

  // Calculate offset for staggered layout
  const getOffset = () => {
    switch (index) {
      case 0:
        return "lg:ml-32";
      case 1:
        return "lg:ml-64";
      case 2:
        return "lg:ml-32";
      default:
        return "";
    }
  };

  return (
    <div
      className={`relative ${getOffset()} transition-all duration-300 hover:-translate-y-1`}
    >
      <div className="bg-white rounded-xl shadow-lg overflow-hidden flex items-center max-w-xl mx-auto lg:mx-0">
        <div className="w-1/3">
          <img
            // src={`${process.env.REACT_APP_COURSE_API_BASEURL}${image}` || "/placeholder.svg"}
            src={image}
            alt={title}
            className="w-full h-35 object-cover"
          />
        </div>
        <div className="w-2/3 p-6">
          <h3 className="text-lg md:text-xl font-semibold text-gray-900 mb-2">
            {t(title)}
          </h3>
          <p className="!text-gray-900 !text-left">{t(subtitle)}</p>
        </div>
      </div>
    </div>
  );
};

export default TalentCard;
